export default __webpack_public_path__ + "static/media/codeofconduct.31d64566.pdf";